module.exports = __webpack_public_path__ + "static/media/AI.5d2e9c81.png";